// ** React Imports
import { Link } from 'react-router-dom'

// ** Custom Components

// ** Third Party Components
import { Settings, Power, Award, Box, Briefcase } from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'

// ** Default Avatar Image
// import defaultAvatar from '@src/assets/images/portrait/small/avatar-s-11.jpg'
import { useContext, useEffect, useState } from 'react'
// import { getReq } from '../../../../assets/auth/jwtService'
import { removeToken, TOKEN_KEY } from '../../../../assets/auth/auth'
import { PermissionProvider } from '../../../../Helper/Context'
import Cookies from 'js-cookie'
import { getReq, HOMEURL, omcDomain } from '../../../../assets/auth/jwtService'

export const logoutFromDomains = () => {
  const domains = [
    `${omcDomain}/userLogout`,
    'https://dom3.com/userLogout'
  ]
  domains.forEach(url => {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    document.body.appendChild(iframe)
    console.log("iframe", iframe)
  })
  Cookies.remove(TOKEN_KEY)
  Cookies.remove('superUser')
  localStorage.removeItem("userPermission")
  localStorage.removeItem("whatsappUserPermission")
}
const UserDropdown = () => {
  // const [outletData, setOutletData] = useState([])
  const { userPermission } = useContext(PermissionProvider)
  const [data, setData] = useState({
    accDetails: {},
    firstName: "",
    lastName: "",
    user_email: ""
  })

  // const removePermision = () => {
  //   setUserPermission({
  //     appName: '',
  //     multipleDomain: [],
  //     apiKey: '',
  //     installedApps: [],
  //     campaign: []
  //   })
  // }

  const getData = () => {
    getReq('accDetails')
      .then((res) => {
        const updatedData = {
          accDetails: res?.data?.data?.merchant_profile,
          firstName: res?.data?.data?.merchant_profile?.first_name,
          lastName: res?.data?.data?.merchant_profile?.last_name,
          user_email: res?.data?.data?.merchant_profile?.user_email
        }
        setData((pre) => ({
          ...pre,
          ...updatedData
        }))
      })
      .catch((err) => {
        console.log(err)
      })
  }

  // console.log(userPermission, "userPermission")
  const LogOut = (e) => {
    e.preventDefault()
    getReq("logoutEntry")
      .then(() => {
        // removePermision()
        removeToken()
        Cookies.remove('superUser')
        console.log(HOMEURL, "Logout successful")
        window.location.href = `${HOMEURL}/merchant/login/`
      })
      .catch((err) => {
        console.log(err)
        // removePermision()
        removeToken()
        Cookies.remove('superUser')
        window.location.href = `${HOMEURL}/merchant/login/`
      })
    logoutFromDomains()
  }


  // const getData = () => {
  //   getReq('saveOutletDetails')
  //   .then((data) => data.json())
  //   .then((resp) => {
  //     setOutletData(resp.data.data.outlet_detail)
  //   })
  //   .catch((error) => {
  //     console.log(error)
  //   })
  // }

  useEffect(() => {
    getData()
  }, [])

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold text-capitalize' style={{ whiteSpace: 'nowrap' }}>
            {userPermission?.logged_in_user?.user_first_name}
          </span>
          {<span className='user-status' style={{ whiteSpace: 'nowrap' }}>{userPermission?.logged_in_user?.user_role}</span>}
        </div>
        {/* <Avatar img={defaultAvatar} imgHeight='40' imgWidth='40' status='online' /> */}
        <span className='d-flex justify-content-center align-items-center' style={{ width: '40px', height: '40px', borderRadius: '6000px', fontSize: "100%", color: "white", backgroundColor: "#7367f0", textTransform: 'uppercase' }}>
          {
            data?.firstName && data?.lastName ? `${data?.firstName[0]}${data?.lastName[0]}` : data?.user_email[0]
          }
        </span>
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to='/merchant/admin_view/'>
          <Settings size={14} className='me-75' />
          <span className='align-middle'>Global Settings</span>
        </DropdownItem>
        {/* <DropdownItem tag={Link} to='/merchant/admin_view/'>
          <User size={14} className='me-75' />
          <span className='align-middle'>Profile</span>
        </DropdownItem> */}
        <DropdownItem tag={Link} to='/merchant/company/profile/'>
          <Award size={14} className='me-75' />
          <span className='align-middle'>Company</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/merchant/outlets/'>
          <Box size={14} className='me-75' />
          <span className='align-middle'>Domains</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/merchant/customers/add-dept/'>
          <Briefcase size={14} className='me-75' />
          <span className='align-middle'>Department</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='/merchant/customers/Manage-user/'>
          <Briefcase size={14} className='me-75' />
          <span className='align-middle'>Users</span>
        </DropdownItem>
        <DropdownItem divider />
        {/* <DropdownItem tag={Link} to='/merchant/admin_view/'>
          <Settings size={14} className='me-75' />
          <span className='align-middle'>Settings</span>
        </DropdownItem> */}
        {/* <DropdownItem tag={Link} to='/merchant/faqs/'>
          <HelpCircle size={14} className='me-75' />
          <span className='align-middle'>FAQ</span>
        </DropdownItem> */}
        <DropdownItem to="/" tag={Link} onClick={(e) => LogOut(e)}>
          <Power size={14} className='me-75' />
          <span className='align-middle'>Logout</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
